export const getEmployeeImageUrl = (
  users: any,
  id: string,
  currentUser?: any
): string | undefined => {
  const user = users.find((u: any) => u.EmpId === id);
  if (user?.Image) {
    return user.Image;
  }

  if (currentUser?.userDetails?.uid == id) {
    return currentUser?.userDetails?.profile_pic;
  }
  return undefined;
};
